"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var explorerStyle_1 = require("./grids/selectBehaviours/explorerStyle");
var configuration_1 = require("./configuration");
var MultipleSelectionGrid_1 = require("./grids/MultipleSelectionGrid");
var NonSelectableGrid_1 = require("./grids/NonSelectableGrid");
var NoScrollBarScrollPan_1 = require("./grids/NoScrollBarScrollPan");
var twoSideLayout_1 = require("./layouts/twoSideLayout");
var VIEW_IDS = {
    TOTAL_GRID: "TotalGrid"
};
function createGrid(id) {
    var grid = new NonSelectableGrid_1.nonSelectableGridClass();
    grid.setId(id);
    return grid;
}
var MainLayout = (function () {
    function MainLayout() {
        this._totalGrid = createGrid(VIEW_IDS.TOTAL_GRID);
        this._tableGrid = new MultipleSelectionGrid_1.multiGridClass(new explorerStyle_1.ExplorerStyle(), this.getSmallFont(), this._rows);
        this._mediumGrid = new MultipleSelectionGrid_1.multiGridClass(new explorerStyle_1.ExplorerStyle(), this.getSmallFont(), this._rows);
        this._presetGrid = new NonSelectableGrid_1.nonSelectableGridClass(this.getSmallFont());
    }
    Object.defineProperty(MainLayout.prototype, "rows", {
        set: function (rows) {
            this._rows = rows;
        },
        enumerable: true,
        configurable: true
    });
    MainLayout.prototype.getPresetGrid = function () {
        return this._presetGrid;
    };
    MainLayout.prototype.getTableGrid = function () {
        return this._tableGrid;
    };
    MainLayout.prototype.getMediumGrid = function () {
        return this._mediumGrid;
    };
    MainLayout.prototype.getTableGridCaption = function () {
        return this._tableGridCaption;
    };
    MainLayout.prototype.getMediumGridCaption = function () {
        return this._mediumGridCaption;
    };
    MainLayout.prototype.getTotalGrid = function () {
        return this._totalGrid;
    };
    MainLayout.prototype.generateTablePanel = function (panel, mediumPanelSize) {
        panel.setLayout(new zebra.layout.BorderLayout());
        this.generateScrollPan(mediumPanelSize);
        panel.add(zebra.layout.CENTER, this._centerPan);
        this.setGridColors();
        this.setGridPaddings();
    };
    MainLayout.prototype.generateViewComboPan = function () {
        var viewComboPan = new zebra.ui.Panel();
        var rightFlowLayout = new zebra.layout.FlowLayout(zebra.layout.RIGHT, zebra.layout.CENTER, zebra.layout.HORIZONTAL, configuration_1.PlanConfiguration.flowLayoutGap);
        viewComboPan.setLayout(new zebra.layout.PercentLayout());
        var vPadding = 0;
        var hPadding = 5;
        var presetRowLabel = this.getAlignedLabel("Vorgabe neue/markierte Belegungen: ", zebra.layout.RIGHT, vPadding, hPadding, vPadding, hPadding);
        var presetPan = new zebra.ui.Panel();
        presetPan.setLayout(rightFlowLayout);
        presetPan.add(presetRowLabel);
        var presetPanWidth = 30;
        viewComboPan.add(presetPanWidth, presetPan);
        return viewComboPan;
    };
    MainLayout.prototype.setGridColors = function () {
        this._presetGrid.setLineColor(configuration_1.PlanConfiguration.gridBorderColor);
        this._mediumGrid.setLineColor(configuration_1.PlanConfiguration.gridBorderColor);
        this._tableGrid.setLineColor(configuration_1.PlanConfiguration.gridBorderColor);
        this._totalGrid.setLineColor(configuration_1.PlanConfiguration.gridBorderColor);
    };
    MainLayout.prototype.setGridPaddings = function (xPadding, yPadding) {
        if (xPadding === void 0) { xPadding = 0; }
        if (yPadding === void 0) { yPadding = 0; }
        this._tableGrid.setCellPaddings(yPadding, xPadding, yPadding, xPadding);
        this._mediumGrid.setCellPaddings(yPadding, xPadding, yPadding, xPadding);
        this._presetGrid.setCellPaddings(yPadding, xPadding, yPadding, xPadding);
        this._totalGrid.setCellPaddings(yPadding, xPadding, yPadding, xPadding);
    };
    MainLayout.prototype.generateScrollPan = function (mediumPanelSize) {
        this._tableGridCaption = new zebra.ui.grid.CompGridCaption([]);
        this._tableGrid.add(zebra.layout.TOP, this._tableGridCaption);
        this._mediumGridCaption = new zebra.ui.grid.CompGridCaption([]);
        this._mediumGridCaption.isResizable = false;
        this._mediumGrid.add(zebra.layout.TOP, this._mediumGridCaption);
        var gridBottomPadding = 10;
        this._mediumGrid.setPadding(0, 0, gridBottomPadding, 0);
        var vPadding = 5;
        var hPadding = 0;
        this._presetGrid.setPadding(vPadding, hPadding, vPadding, hPadding);
        this._tableGridScrollPan = new zebra.ui.ScrollPan(this._tableGrid, zebra.layout.VERTICAL);
        this._tableGridScrollPan.setPadding(0, 0, gridBottomPadding, 0);
        this._mediumGridScrollPan = new NoScrollBarScrollPan_1.noScrollBarScrollPan(this._mediumGrid);
        this._centerPan = new zebra.ui.Panel(new zebra.layout.BorderLayout());
        this._totalGridScrollPan = new zebra.ui.ScrollPan(this._totalGrid, zebra.layout.HORIZONTAL);
        this._totalGridScrollPan.setPreferredSize(-1, configuration_1.PlanConfiguration.totalGridScrollHeight);
        var elements = this.createTableComponents(mediumPanelSize);
        this._centerPan.add(zebra.layout.TOP, elements.topPanel);
        this._centerPan.add(zebra.layout.CENTER, elements.centerPanel);
        this._centerPan.add(zebra.layout.BOTTOM, elements.bottomPanel);
    };
    MainLayout.prototype.getScrollBarMax = function () {
        return this._tableGridScrollPan.vBar.max;
    };
    MainLayout.prototype.createTableComponents = function (mediumSize) {
        var borderOffset = 0;
        var layout = new twoSideLayout_1.twoSideLayout(mediumSize + borderOffset);
        layout.setGap(0);
        var topPercent = new zebra.ui.Panel(layout);
        var centerPercent = new zebra.ui.Panel(layout);
        var bottomPercent = new zebra.ui.Panel(layout);
        topPercent.add(this.generateViewComboPan());
        topPercent.add(this._presetGrid);
        centerPercent.add(this._mediumGridScrollPan);
        centerPercent.add(this._tableGridScrollPan);
        var vPadding = 5;
        var hPadding = 0;
        bottomPercent.add(this.getAlignedLabel("Planwerte Gesamt", zebra.layout.RIGHT, vPadding, hPadding, vPadding, hPadding));
        bottomPercent.add(this._totalGridScrollPan);
        return { topPanel: topPercent, centerPanel: centerPercent, bottomPanel: bottomPercent };
    };
    MainLayout.prototype.getAlignedLabel = function (text, alignment, pTop, pLeft, pBottom, pRight) {
        var result = new zebra.ui.Panel(new zebra.layout.FlowLayout(alignment, zebra.layout.TOP, zebra.layout.VERTICAL));
        var label = new zebra.ui.Label(text);
        if (pTop) {
            if (pLeft && pRight && pBottom) {
                label.setPadding(pTop, pLeft, pBottom, pRight);
            }
            else {
                label.setPadding(pTop);
            }
        }
        label.setFont(this.getStandardFont());
        label.setColor(configuration_1.PlanConfiguration.textColor);
        result.add(label);
        return result;
    };
    MainLayout.prototype.getStandardFont = function (bold, sizeOffset) {
        if (sizeOffset === void 0) { sizeOffset = 0; }
        if (bold && bold === true) {
            return new zebra.ui.Font(configuration_1.PlanConfiguration.fontType, "bold", configuration_1.PlanConfiguration.fontSize + sizeOffset);
        }
        return new zebra.ui.Font(configuration_1.PlanConfiguration.fontType, configuration_1.PlanConfiguration.fontSize + sizeOffset);
    };
    MainLayout.prototype.getSmallFont = function (bold) {
        var fontSize = configuration_1.PlanConfiguration.fontSize + configuration_1.PlanConfiguration.smallFontOffset;
        if (bold && bold === true) {
            return new zebra.ui.Font(configuration_1.PlanConfiguration.fontType, "bold", fontSize);
        }
        return new zebra.ui.Font(configuration_1.PlanConfiguration.fontType, fontSize);
    };
    MainLayout.prototype.getBigFont = function (bold) {
        var fontSize = configuration_1.PlanConfiguration.fontSize + configuration_1.PlanConfiguration.bigFontOffset;
        if (bold && bold === true) {
            return new zebra.ui.Font(configuration_1.PlanConfiguration.fontType, "bold", fontSize);
        }
        return new zebra.ui.Font(configuration_1.PlanConfiguration.fontType, fontSize);
    };
    MainLayout.prototype.getBorder = function (borderRadius) {
        if (borderRadius === void 0) { borderRadius = 0; }
        return new zebra.ui.Border(configuration_1.PlanConfiguration.borderColor, 1, borderRadius);
    };
    MainLayout.prototype.setDeleteHandler = function (deleteHandler) {
        this._tableGrid = new MultipleSelectionGrid_1.multiGridClass(new explorerStyle_1.ExplorerStyle(deleteHandler), this.getSmallFont(), this._rows);
        this._mediumGrid = new MultipleSelectionGrid_1.multiGridClass(new explorerStyle_1.ExplorerStyle(deleteHandler), this.getSmallFont(), this._rows);
    };
    MainLayout.prototype.scrollToBottom = function () {
        if (this._tableGridScrollPan.vBar.isVisible) {
            this._tableGridScrollPan.vBar["position"].setOffset(this._tableGridScrollPan.vBar.max);
        }
    };
    return MainLayout;
}());
exports.MainLayout = MainLayout;
//# sourceMappingURL=mainLayout.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/mainLayout.js
// module id = 74
// module chunks = 0